import type { PropsWithChildren } from "react";

import { NoInformation } from "@/components/NoInformation/NoInformation";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function Stage({ children }: PropsWithChildren) {
  return (
    <div className="flex h-96 rounded-md border border-border bg-card p-4">
      {children}
    </div>
  );
}

export function PlaygroundSectionNoInformation() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>No information</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          State shown in place of the transcript panel when a call has no
          recording and no transcription (CI-6374). The rest of the page - Call
          info, Notes, tagging - stays reachable (CI-6448).
        </p>
        <Stage>
          <NoInformation />
        </Stage>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
